import React, { useState } from 'react'
import DataTable from '../components/DataTable'
import { KTSVG } from '../../_metronic/helpers'
import EmployeeCreate from '../components/EmployeeCreate'

function Employee(props) {

	const [newData, setNewData] = useState('');
	const [id, setId] = useState('');
	const [name, setName] = useState('');

	const onCreate = ({ id, name }) => {
		console.log(name);
		setNewData({ id: id, name: name });
	}

	const columns = [
		{ value: 'id', title: 'Id', style: { textAlign: 'center' } },
		{ value: 'employeeId', title: 'Employee ID', style: { textAlign: 'left' } },
		{ value: 'employeeName', title: 'Employee Name', style: { textAlign: 'left' } },
		{ value: 'mobileNo', title: 'mobileNo', style: { textAlign: 'left' } },
		{ value: 'email', title: 'email', style: { textAlign: 'left' } },
		{ value: 'department', title: 'department', style: { textAlign: 'left' } },
		{ value: 'designation', title: 'designation', style: { textAlign: 'left' } },
		{ value: 'grossSalary', title: 'Gross Salary', style: { textAlign: 'left' } },
		{
			value: 'action', title: 'Action', actions: [
				{ link: 'edit', calAction: true }
			],
			style: { textAlign: 'center' }
		}
	]

	const filters = {
		id: {
			filterType: 'like',
			filterValue: '',
		},
		employeeId: {
			filterType: 'like',
			filterValue: '',
		},
		employeeName: {
			filterType: 'like',
			filterValue: '',
		},
		mobileNo: {
			filterType: 'like',
			filterValue: '',
		},
		email: {
			filterType: 'like',
			filterValue: '',
		},
		department: {
			filterType: 'like',
			filterValue: '',
		},	
		designation: {
			filterType: 'like',
			filterValue: '',
		},
		grossSalary: {
			filterType: 'like',
			filterValue: '',
		}

	}

	const url = process.env.REACT_APP_API_URL + 'production_employee_dt'

	const onAction = (data) => {
		console.log(data)
		setId(data.id);
		setName(data.operationName);
	}

	return (
		<>
			<div className='card card-custom'>
				<div className='card-header'>
					<div className='card-title'>
						<KTSVG
							path='/media/icons/duotune/text/txt001.svg'
							className='svg-icon-1 svg-icon-primary'
						/>
						<span className='text fw-bolder' style={{ marginLeft: '10px' }}>
							Employee 
						</span>
					</div>
				</div>

				<div className='card-body'>
					<EmployeeCreate onCreate={onCreate} id={id} name={name} />

					<DataTable url={url} columns={columns} filters={filters} newData={newData} onAction={onAction}>

						<span className='svg-icon svg-icon-md svg-icon-primary'>
							<KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-1 svg-icon-3' />
						</span>

					</DataTable>


				</div>
			</div>
		</>
	)
}

export default Employee
